

import React, { useState, useEffect } from 'react';
import { Button, Typography, Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import LoginPhone from "./login-phone";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import LoginPass from "./login-pass";
import RegSecurity from "./login-newpass";
import ForgetSMSCode from "./login-sms";
import { blueGrey } from '@mui/material/colors';
import Notification from "../../notification/notification"
import CircularProgress from '@mui/material/CircularProgress';
// import dynamic from 'next/dynamic';

// const WaitingView = dynamic(
//     () => import("../../Maps/detail/common/Progress/back-drop"),
//     { ssr: false }
// )


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}))


export default function DialogLogin({open, newPage, flagRun, onBack}) {
    const [phoneData, setPhoneData] = useState({
        mobile_number: ''
    })
    const [menuItem, setMenuItem] = useState(0)

    const [loading, setLoading ] = useState(false)

    const [notiShow, setNotiShow] = useState(false)
    const [notiTitle, setNotiTitle] = useState('')
    const [notiType, setNotiType] = useState("success")
    // const [scroll, setScroll] = useState<DialogProps['scroll']>('paper')
    // const size = useWindowSize()

    // const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
    //     // setOpen(true)
    //     setScroll(scrollType)
    // }
    useEffect(() => {
        // console.log(newPage);
        
        setPhoneData('')
        setMenuItem(0)
    }, [newPage])
    

    const handleClose = () => {
        onBack({
            close: true
        })
    }

    // const handleRegSMSCode = async(userPhone:string) => {
    //     setLoading(true)
    //     await getProfileExist({per_code: codePrson, phone_number: userPhone})
    //     .then(res => {
    //         setLoading(false)
    //         // console.log(res?.message);
    //         if(!res.Error){
    //             if(res?.message !== "Ok"){
    //                 setNotiShow(true)
    //                 setNotiTitle(res?.message)
    //                 setNotiType("success")
    //             }
    //             // const dataRes = {code_prs: codePrson, mobileNumber: mobileNumber}
    //             // onNext(dataRes)
    //             // setTimerRemain(120)
    //             // handleStart()
    //             const dataRes = {
    //                 code_prs: codePrson, 
    //                 mobile_number: mobileNumber,
    //             }
    //             onBack(dataRes)
    //         }else if(res?.message){
    //             setNotiShow(true)
    //             setNotiTitle(res?.message)
    //             setNotiType("error")
    //         }
    //     })
    //     .catch(e => {
    //         setLoading(false)
    //     })
    // }

    const handleNewPassOnBack = (value) => {
        
        // console.log(value);
        
        if(value?.close)
        {
            onBack({
                close: true
            })
        }else{
            setMenuItem(1)
        }
        setPhoneData(value)
    }

    const handleSMSOnBack = (value) => {
        // const dataRes = {
        //     sms_code: SMSCode, 
        //     mobile_number: userPhone,
        //     token: res?.token ? res?.token : ''
        // }
        // console.log(value);
        
        setMenuItem(3)
        setPhoneData(value)
    }

    const handleOnBack = (value) => {
        
        // console.log(value);
        
        if(value?.login)
        {
            setMenuItem(2)
        }else{
            setMenuItem(1)
        }
        setPhoneData(value)
    }

    const handleOnChangeNum = (value) => {
        setMenuItem(0)
    }

    const handlePassBack = (value) => {
        // console.log(value);
        if(value?.change_num)
        {
            setMenuItem(0)
        }else if(value?.close){
            onBack(value)
        }else if(value?.sms){
            setMenuItem(1)
        }
        setPhoneData(value)
    }

    const handlerBackNoti = () => {
        setNotiShow(false)
    }

    return (
        <div className="w-full h-full">
            {loading &&
                // <WaitingView openWait={loading} onCloseClick={false} />
                <CircularProgress  />
            }
            <BootstrapDialog
                open={open}
                onClose={handleClose}
                keepMounted
                maxWidth={'sm'}
                fullWidth={true}
                >
                <div className='text-left'>
                    <Button onClick={handleClose}>
                        <CloseIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    </Button>
                </div>
                <DialogTitle>
                    <div dir='rtl' className='text-left -mt-5 pb-5'>
                        <Typography 
                            fontFamily='vaziri_light'
                            component={"span"}
                            variant={"h6"} 
                            color={blueGrey[600]}
                            sx={{
                                textAlign: 'left'
                            }}
                            >
                            {"ورود به حساب کاربری"}
                        </Typography>
                    </div>
                </DialogTitle>
                <Divider />
                <DialogContent >
                    <div dir='rtl' className='text-center'>
                        {menuItem === 2 ?
                            <LoginPass 
                                userPhone={phoneData?.mobile_number} 
                                num_check={phoneData?.num_check}
                                onBack={handlePassBack}
                                flagRun={flagRun}
                                />
                        :
                            menuItem === 1 ?
                                <ForgetSMSCode 
                                    userPhone={phoneData?.mobile_number} 
                                    num_check={phoneData?.num_check}
                                    typeSMS={phoneData?.type_sms}
                                    onBack={handleSMSOnBack}
                                    onChangeNum={handleOnChangeNum}
                                    />
                            :
                            menuItem === 3 ?
                                <RegSecurity 
                                    userPhone={phoneData?.mobile_number} 
                                    sms_code={phoneData?.sms_code}
                                    num_check={phoneData?.num_check}
                                    // typeSMS={phoneData?.type_sms ? phoneData?.type_sms : 0}
                                    onBack={handleNewPassOnBack}
                                    />
                            :
                                <LoginPhone 
                                    userPhone={phoneData?.mobile_number} 
                                    onBack={handleOnBack}
                                    />
                        }
                    </div>
                </DialogContent>
            </BootstrapDialog>
            <div>
                <Notification
                    viewNoti={notiShow}
                    title={notiTitle} 
                    severity={notiType}
                    onBack={handlerBackNoti}
                    />
            </div>
        </div>
    )
}